<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      brands: [],
      loading: false,
      filters: {
        brand: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Centauro.vue?0a13a3be